import React from 'react';

import ActionLink from '../builder/ActionLink';
import Tooltip from '../builder/Tooltip';

import UserAvatar from './UserAvatar';

const Wrapper = (props) => {
	const tooltip = props?.tooltip ?? false;
	const is_builder = props?.is_builder ?? false;
	const is_only_name = props?.is_only_name ?? false;

	let _class = [
		'gui_username_flex',
		'name',
		(props?.classes ?? 'gui_winner_name'),
	];
	if(is_builder) _class.push('is_builder');
	if(is_only_name) _class.push('is_only_name');

	return (
		<span class={_class.join(" ")}>
			{props.children}

			{(tooltip) && (
				<Tooltip icon="knk-information" size="big">{tooltip}</Tooltip>
			)}
		</span>
	)
};

const UserInfo = ({ user, name, ...props }) => {
	const display_avatar = props?.display_avatar ?? true;
	const is_multiline = props?.multiline ?? false;
	const extra = props?.extra ?? null;
	const _href = props?._href ?? false;

	let name_classes = ['is_name'];
	if(!is_multiline) {
		name_classes.push('gui_cutTextOnOverflow gui_pos_rel_important');
	} else {
		name_classes.push('is_multiline');
	}

	return (
		<>
			{(display_avatar) && (
				<UserAvatar
					user={user}
					is_builder={props.is_builder}
					extra_class={props.extra_class}
				/>
			)}

			<div class="is_username">
				{(_href !== false) ? (
					<ActionLink
						_href={_href}
						_target={props._target}
						_class={{ other:name_classes.join(" ") }}
						autotranslate={false}
					>{name}</ActionLink>
				) : (
					<span class={name_classes.join(" ")}>{name}</span>
				)}

				{extra}
			</div>
		</>
	)
};

const UserName = (props) => {
	const user = props.user;
	const _link_usernames = window?.link_usernames ?? false;

	let target = '_blank';
	let url = false;
	let name = false;
	if(user.network != undefined) {
		switch(user.network) {
			case 'facebook':
				if(_link_usernames) url = `https://www.facebook.com/${user.id}`;
				name = user.name;
				break;

			case 'twitter':
				if(_link_usernames) url = `https://twitter.com/${user.username}`;
				name = `@${(user.username != undefined) ? user.username : user.name}`;
				break;

			case 'youtube':
				if(_link_usernames) url = `https://www.youtube.com/channel/${user.id}`;
				name = user.name;
				break;

			case 'instagram':
				let username = user.username != '' ? user.username : (user.name).replace('@','');
				if(_link_usernames) url = `https://www.instagram.com/${username}`;
				name = `@${username}`;
				break;

			case 'app':
			default:
				if(_link_usernames) {
					url = `mailto:${user.name}`;
					target = '_self';
				}
				name = user.name;
				break;
		}
	} else if(user.name != undefined) {
		name = user.name;
	} else {
		name = 'Unknown';
	}

	if(props.children != undefined) name = props.children;

	const link = props?.link ?? false;
	if(link) url = link;

	const entry_public = props?.public ?? false;
	const user_id = user?.user_id ?? false;
	if(user_id && user_id != '' && entry_public && entry_public != '0') {
		// Public entries, we redirect to the "voteme" page of the entrant:
		url = `/voteme/${user.promotion_id}/${user_id}/`;
	}

	const is_linked = props?.linked ?? true;
	if(!is_linked) url = false;

	const onlyname = props?.onlyname ?? false;
	if(onlyname) {
		return (
			<Wrapper
				classes={props._class}
				tooltip={props.tooltip}
				is_only_name={true}
			>
				{name}
			</Wrapper>
		)
	}

	const is_multiline = props?.multiline ?? false;

	if(url) {
		return (
			<Wrapper
				classes={props._class}
				is_builder={props.is_builder}
				tooltip={props.tooltip}
			>
				<UserInfo
					user={user}
					multiline={is_multiline}
					name={name}
					_href={url}
					_target={target}
					display_avatar={props.display_avatar}
					extra={props.extra}
					extra_class={props.extra_class}
					is_builder={props.is_builder}
				/>
			</Wrapper>
		)
	}

	return (
		<Wrapper
			classes={props._class}
			is_builder={props.is_builder}
		>
			<UserInfo
				user={user}
				multiline={is_multiline}
				name={name}
				display_avatar={props.display_avatar}
				extra={props.extra}
				extra_class={props.extra_class}
				is_builder={props.is_builder}
			/>
		</Wrapper>
	);
};

export default UserName;